const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export type ExportFormat = 'Pdf' | 'Pptx';

export type EngagementSection =
  | 'EngagementIndex'
  | 'TrendChart'
  | 'DriverScores'
  | 'TeamBreakdown'
  | 'Comments';

export type QoHSection =
  | 'SummaryMetrics'
  | 'ScoresBySource'
  | 'ScoresByDepartment'
  | 'RoundHistory';

async function downloadExport(
  url: string,
  body: unknown,
  accessToken: string
): Promise<void> {
  const res = await fetch(`${BASE}${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`Export failed: ${res.status}`);

  const blob = await res.blob();
  const contentDisposition = res.headers.get('Content-Disposition') ?? '';
  const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
  const fileName = fileNameMatch?.[1] ?? 'GridPulse-Export';

  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}

export async function exportEngagement(
  accessToken: string,
  surveyId: string,
  format: ExportFormat,
  sections: EngagementSection[],
  commentary?: string
): Promise<void> {
  await downloadExport('/api/exports/engagement', { surveyId, format, sections, commentary }, accessToken);
}

export async function exportQoH(
  accessToken: string,
  format: ExportFormat,
  sections: QoHSection[],
  commentary?: string,
  dateFrom?: string,
  dateTo?: string
): Promise<void> {
  await downloadExport('/api/exports/qoh', { format, sections, commentary, dateFrom, dateTo }, accessToken);
}
